import type { IncomingMessage } from 'http';
import {
  type BooleanFlagKey,
  type FeatureFlagKey,
  featureFlags,
  type VariantFlagKey,
  type VariantValuesFor,
} from './flags';
import { getAllFlagValues } from './cookies';

type FeatureFlagRequest =
  | IncomingMessage
  | {
      headers: Headers;
    };

function getCookieHeader(req: FeatureFlagRequest): string {
  if (req.headers instanceof Headers) {
    return req.headers.get('cookie') ?? '';
  }

  return req.headers.cookie ?? '';
}

export function getFeatureFlags(req: FeatureFlagRequest): Record<FeatureFlagKey, string | boolean> {
  return getAllFlagValues(getCookieHeader(req));
}

export function isFeatureFlagEnabled(req: FeatureFlagRequest, key: BooleanFlagKey): boolean {
  const flags = getFeatureFlags(req);
  return flags[key] === true;
}

export function getFeatureFlagVariant<K extends VariantFlagKey>(
  req: FeatureFlagRequest,
  key: K,
): VariantValuesFor<K> {
  const flags = getFeatureFlags(req);
  const value = flags[key];
  const flag = featureFlags.find((f) => f.key === key);

  if (
    flag &&
    flag.type === 'variant' &&
    typeof value === 'string' &&
    flag.variants.includes(value as never)
  ) {
    return value as VariantValuesFor<K>;
  }

  if (flag && flag.type === 'variant') {
    return flag.defaultValue as VariantValuesFor<K>;
  }

  return '' as VariantValuesFor<K>;
}
